import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import IReelsConfig from '../../vendor_core/core/src/managers/contracts/configurations/IReelsConfig';
import IIndividualReelSpinDelayConfig from '../../vendor_core/core/src/managers/contracts/configurations/reels/IIndividualReelSpinDelayConfig';

class ReelsConfig implements IReelsConfig {
    type: ConfigurationTypes = ConfigurationTypes.REEL;
    clientMinSpinTime?: number = 2400;
}

export default new ReelsConfig()
